// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
// filters
import filters from './filters'
// http
import model from './http'
// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/css/overwrite.css'
import 'assets/css/global.css'
import 'assets/css/app.css'
import 'normalize.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.$model = model

Object.keys(filters).forEach(name => {
  Vue.filter(name, filters[name])
})

/* eslint-disable no-new */
new Vue({
  store,
  router
}).$mount('#app')
